import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import {
  makeGoalStaticsEmpData,
  makeHeaderRow,
} from '../../utils/goal_statics';
import GoalStaticsEmpTable from '../../components/goal_statics/GoalStaticsEmpTable';
import * as staticsApi from '../../lib/api/statics';

const GoalStaticsEmployeeContainer = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchDate,
  selectedGbn,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  // const onLoadData = () => {
  //   setLoading(true);
  //   const loadedHeaders = makeHeaderRow(strMonth, endMonth);
  //   const loadedData = makeGoalStaticsEmpData(loadedHeaders);
  //   setHeaderRows(loadedHeaders);
  //   setData(loadedData);
  //   console.log(JSON.stringify(loadedData));
  //   setLoading(false);
  // };

  const onLoadData = async () => {
    setLoading(true);

    try {
      const loadedHeaders = makeHeaderRow(strMonth, endMonth);
      const res = await staticsApi.getEmpExpectStatics(
        selectedYear,
        strMonth,
        endMonth,
        selectedGbn,
      );
      if (res.data.list) {
        setHeaderRows(loadedHeaders);
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchDate) {
      onLoadData();
    }
  }, [searchDate]);

  return (
    <GoalStaticsEmpTable
      data={data}
      loading={loading}
      headerRows={headerRows}
      tableRef={tableRef}
    />
  );
};

export default GoalStaticsEmployeeContainer;
